/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_Closed_CaptioningInputs */



/**
* | output |
* | --- |
* | "Closed Captioning" |
*
* @param {Shortcut_Keys_Group_Closed_CaptioningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_closed_captioning = /** @type {((inputs?: Shortcut_Keys_Group_Closed_CaptioningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_Closed_CaptioningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titrage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos cerrados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("隐藏式字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クローズドキャプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद अनुशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas ocultas")
	return /** @type {LocalizedString} */ ("Closed Captioning")
});